"use strict";
exports.__esModule = true;
exports.useInitializeContext = exports.useModalContext = exports.ModalContext = void 0;
var react_1 = require("react");
exports.ModalContext = react_1.createContext(undefined);
var useModalContext = function () {
    var context = react_1.useContext(exports.ModalContext);
    if (!context) {
        throw new Error('useModalContext must be inside a Modal');
    }
    return context;
};
exports.useModalContext = useModalContext;
var useInitializeContext = function (_a) {
    var opened = _a.opened, onChange = _a.onChange;
    var _b = react_1.useState(!!opened), openedFromState = _b[0], setOpened = _b[1];
    react_1.useEffect(function () {
        setOpened(opened);
    }, [opened]);
    var toggleOpen = function (value) {
        setOpened(value);
        if (onChange) {
            onChange(value);
        }
    };
    return { opened: openedFromState, toggleOpen: toggleOpen };
};
exports.useInitializeContext = useInitializeContext;
//# sourceMappingURL=ModalContext.js.map